import {GumroadSale} from "../models/GumroadSale";

export function buildGumroadSaleFromFirestore(doc) {
	return GumroadSale.buildFromFirestore(doc);
}